import axios from 'axios'
import React, { useState, useContext, useEffect } from 'react'
import dayjs from 'dayjs'

import { Autocomplete, TextField } from '@mui/material';
import { baseUrl } from '../../../baseUrl';
import ConfirmDialog from '../../../components/ConfirmDialog';
import AlertDialog from '../../../components/AlertDialog';
import { UserContext } from '../../../Contexts/UserContext';
import { generateAndDownloadBill } from './generateAdvanceReceiptPDF';

function RelieveInmatesClerk() {
    const { setLoading, user } = useContext(UserContext);

    const [hostelAdmissionNo, setHostelAdmissionNo] = useState("")
    const [open1, setOpen1] = useState("");
    const [open2, setOpen2] = useState("");
    const [modalText, setModalText] = useState("");
    const [modalHeading, setModalHeading] = useState("");

    const [inmates, setInmates] = useState([]);
    const [inmate, setInmate] = useState({})
    const [joiningDate, setJoiningDate] = useState()
    const [vacatingDate, setVacatingDate] = useState()
    const [calculatedAdvanceAmount, setCalculatedAdvanceAmount] = useState(0)
    const [additionalAmount, setAdditionalAmount] = useState(0)
    const [totalAdvanceAmount, setTotalAdvanceAmount] = useState(0)
    const [maxMessBill, setMaxMessBill] = useState(0)
    const [lastBillMonth, setLastBillMonth] = useState(null)
    const [messAdvance, setMessAdvance] = useState(0);
    const [lastBillYear, setLastBillYear] = useState(null)

    // Calculate days from last bill month to vacating date
    const calculateDaysFromLastBill = (lastMonth, lastYear, vacatingDate) => {
        if (!lastMonth || !lastYear || !vacatingDate) return 0;

        const lastBillDate = dayjs().year(lastYear).month(lastMonth - 1).endOf('month');
        const vacatingDateObj = dayjs(vacatingDate);

        let totalDays = 0;
        let currentDate = lastBillDate.add(1, 'day');

        while (currentDate.isBefore(vacatingDateObj) || currentDate.isSame(vacatingDateObj, 'day')) {
            totalDays++;
            currentDate = currentDate.add(1, 'day');
        }

        return totalDays;
    };

    const handleOptionChange = (event, newValue) => {
        if (!newValue) return;

        setLoading(true);
        axios.get(`${baseUrl}/clerk-a3/inmate-details-partial-relieve`, {
            params: { HostelAdmissionNo: newValue.hostel_admission_no }
        }).then((res) => {
            setInmate(res.data.inmate);
            setMaxMessBill(res.data.maxMessBill || 0);
            setLastBillMonth(res.data.lastBillMonth);
            setLastBillYear(res.data.lastBillYear);
            setMessAdvance(res.data.messAdvance || 0);
            setLoading(false);
        }).catch(err => {
            console.log('err', err)
            setLoading(false)
            setModalHeading("Error");
            setModalText(err.response?.data?.msg || "Error fetching inmate details");
            setOpen1(true);
        })
        setHostelAdmissionNo(newValue.hostel_admission_no)
    }

    // Calculate advance amount when vacating date changes
    useEffect(() => {
        if (vacatingDate && maxMessBill && lastBillMonth && lastBillYear) {
            const days = calculateDaysFromLastBill(lastBillMonth, lastBillYear, vacatingDate);
            console.log('days', days)
            const dailyRate = maxMessBill / 30;
            const calculated = Math.round(days * dailyRate);
            setCalculatedAdvanceAmount(calculated);
            setTotalAdvanceAmount(calculated + Number(additionalAmount));
        }
    }, [vacatingDate, maxMessBill, lastBillMonth, lastBillYear, additionalAmount]);

    const handleAdditionalAmountChange = (e) => {
        const additional = e.target.value
        setAdditionalAmount(additional);
        setTotalAdvanceAmount(calculatedAdvanceAmount + additional);
    };

    const handleSubmit = () => {
        setLoading(true);
        const requestData = {
            hostelAdmissionNo,
            joiningDate,
            vacatingDate,
            advanceAmount: totalAdvanceAmount,
            calculatedAmount: calculatedAdvanceAmount,
            additionalAmount,
            programme: inmate?.programme,
            department: inmate?.department,
            maxMessBill,
            lastBillMonth,
            lastBillYear
        };

        if (!hostelAdmissionNo || !joiningDate || !vacatingDate) {
            setLoading(false);
            setModalHeading("Error");
            setModalText("Please fill all required fields.");
            setOpen1(true);
            return;
        }   

        if(totalAdvanceAmount < 0) {
            setLoading(false);
            setModalHeading("Error");
            setModalText("Total advance amount cannot be negative.");
            setOpen1(true);
            return;
        }   

        axios.post(`${baseUrl}/clerk-a3/partial-relieve-inmate`, requestData)
            .then((res) => {
                setModalHeading("Success");
                setModalText(`Inmate ${hostelAdmissionNo} has been partially relieved. Advance amount of Rs.${totalAdvanceAmount} has been collected.`);
                setLoading(false);
                setOpen1(true);
                if (totalAdvanceAmount > 0) {
                    generateAndDownloadBill({
                        hostel_admission_no: hostelAdmissionNo,
                        admission_no: inmate.admission_no,
                        name: inmate.name,
                        amount: totalAdvanceAmount,
                        payment_type: 'Advance Mess Bill',
                        payment_date: dayjs().format('YYYY-MM-DD'),
                        vacating_date: vacatingDate,
                        receipt_no: res.data.receiptNo,
                    });
                }

                // Reset form
                setInmate({});
                setHostelAdmissionNo("");
                setJoiningDate("");
                setVacatingDate("");
                setCalculatedAdvanceAmount(0);
                setAdditionalAmount(0);
                setTotalAdvanceAmount(0);
            }).catch(err => {
                console.log('err', err);
                setLoading(false);
                setModalHeading("Error");
                setModalText(err.response?.data?.msg || "Error processing partial relief");
                setOpen1(true);
            });
    };

    useEffect(() => {
        axios.get(`${baseUrl}/warden/get-all-inmates`).then((res) => {
            setInmates(res.data);
        }).catch(err => {
            console.log('Error fetching inmates:', err);
        });
    }, []);

    return (
        <div className="w-11/12">
            <h2 className="font-bold text-xl mb-4">Partial Relief - Advance Mess Bill Payment</h2>
            <form className="grid grid-cols-2 gap-4 mb-4 w-full" onSubmit={(e) => {
                e.preventDefault();
                setModalHeading("Confirm Partial Relief");
                setModalText(`You are partially relieving:
                Name: ${inmate?.name}
                Hostel Admission No: ${hostelAdmissionNo}
                College Admission No: ${inmate?.admission_no}
                Vacating Date: ${vacatingDate}
                Calculated Advance Amount: Rs.${calculatedAdvanceAmount}
                Additional Amount: Rs.${additionalAmount}
                Total Advance Amount: Rs.${totalAdvanceAmount}
                
                Do you want to confirm?`);
                setOpen2(true);
            }}>
                <label htmlFor="">Enter Hostel Admission No:</label>
                <Autocomplete
                    id="auto-complete"
                    options={inmates}
                    getOptionLabel={(option) => option.hostel_admission_no}
                    sx={{ width: 300 }}
                    onChange={handleOptionChange}
                    renderInput={(params) => <TextField {...params} label="Admission no" variant="standard" />}
                />

                {Object.keys(inmate).length !== 0 && (
                    <>
                        <label>Name:</label>
                        <p className="py-2">{inmate?.name}</p>

                        <label>College Admission No:</label>
                        <p className="py-2">{inmate?.admission_no}</p>

                        <label>Programme:</label>
                        <p className="py-2">{inmate?.programme}</p>

                        <label>Department:</label>
                        <p className="py-2">{inmate?.department}</p>

                        <label>Last Bill Month/Year:</label>
                        <p className="py-2">{lastBillMonth}/{lastBillYear}</p>

                        {/* <label>Max Mess Bill (6 months):</label>
                        <p className="py-2">Rs.{maxMessBill}</p> */}

                        <label htmlFor="">Joining Date:</label>
                        <input
                            type="date"
                            value={joiningDate}
                            onChange={(e) => setJoiningDate(e.target.value)}
                            className="py-2 px-3 rounded-xl ring-2 ring-slate-300 focus:outline-none"
                            required
                        />

                        <label htmlFor="">Date of Vacating Hostel:</label>
                        <input
                            type="date"
                            min={dayjs().format("YYYY-MM-DD")}
                            value={vacatingDate}
                            onChange={(e) => setVacatingDate(e.target.value)}
                            className="py-2 px-3 rounded-xl ring-2 ring-slate-300 focus:outline-none"
                            required
                        />

                        {vacatingDate && (
                            <>
                                <label> Mess Advance Remited</label>
                                <p className="py-2 font-semibold">Rs.{messAdvance} /-</p>

                                <label>Calculated Advance Amount:</label>
                                <p className="py-2 font-semibold ">Rs.{calculatedAdvanceAmount} /-</p>
                                <label>Advance Amount to be Paid:</label>

                                <p className="py-2 font-semibold">Rs.{calculatedAdvanceAmount - messAdvance} /-</p>

                                <label htmlFor="">Additional Amount (Optional):</label>
                                <input
                                    type="number"
                                    value={additionalAmount}
                                    onChange={handleAdditionalAmountChange}
                                    className="py-2 px-3 rounded-xl ring-2 ring-slate-300 focus:outline-none"
                                    placeholder="Enter additional amount"
                                />

                                <label>Total Advance Amount:</label>
                                <p className="py-2 font-bold text-green-600 text-lg">Rs.{totalAdvanceAmount} /-</p>
                            </>
                        )}

                        <div className="col-span-2">
                            <button
                                className="bg-blue-600 text-white p-3 rounded-lg text-sm w-1/3 hover:bg-blue-700"
                                type='submit'
                                // disabled={!totalAdvanceAmount}
                            >
                                Process Partial Relief
                            </button>
                        </div>
                    </>
                )}
            </form>

            <AlertDialog
                open={open1}
                setOpen={setOpen1}
                modalHeading={modalHeading}
                modalText={modalText}
            />
            <ConfirmDialog
                open={open2}
                setOpen={setOpen2}
                modalHeading={modalHeading}
                modalText={modalText}
                confirmFunction={handleSubmit}
            />
        </div>
    );
}

export default RelieveInmatesClerk;